export default "__VITE_ASSET__CRug6WZS__"